import { defineComponent, PropType } from 'vue';
import { CountryDataItem, MGA_REPORT_TABLE } from '@/models/report/report.model';
import { storeToRefs } from 'pinia';
import { useCountryListStore } from '@/store/dictionary/country-list.store';
import { MapLocation as MapLocationIcon } from '@element-plus/icons-vue';
import { formatUnixToString } from '@marfa/bo-utils';

export default defineComponent({
  name: 'MgaReportList',
  components: { MapLocationIcon },
  props: {
    report: {
      type: Object as PropType<CountryDataItem>,
      required: true,
    },
  },
  setup() {
    const countryListStore = useCountryListStore();
    const { countryList } = storeToRefs(countryListStore);
    const { getCountryName } = countryListStore;

    return {
      MGA_REPORT_TABLE,
      formatUnixToString,
      countryList,
      getCountryName,
    };
  },
});
